import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CircularProgress from '@mui/material/CircularProgress';
import {
    FormGroup,
    Label,

} from 'reactstrap';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    allStudents,
    studentRecentAgreement,
    addContractRenewal,
    agreementAllDetails
} from 'Actions';

class AddItems extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,

    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
        this.props.agreementAllDetails();
    }
    constructor(props) {

        super(props);
        this.state = {
            student: '',
            agreeid:'',
            expirydate:'',
            installment:[],
            totalamount:'',
            miscellexpense:'',
            notes:'',
            duedate_1:'',
            duedate_2:'',
            duedate_3:'',
            duedate_4:'',
            frtax_1:'',
            frtax_2:'',
            frtax_3:'',
            frtax_4:'',
            frfees_1:'',
            frfees_2:'',
            frfees_3:'',
            frfees_4:'',
            selecttype:'',
            loader:false,
            agrdiv:false,
            notdiv:false,

        };

        this.calculateTax = this.calculateTax.bind(this);
        this.calculateTotal = this.calculateTotal.bind(this);
    }

    selstudent = (evt) => {
        var stdid = evt.value;
        this.setState({ student: stdid });

        this.props.studentRecentAgreement(stdid).then((response) => {
            this.setState({loader:false });
            if (response.status == 1) {
                var resdata = response.data;
                var agreement=resdata.agreement[0];
                var constract=resdata.feelist;
                if (Array.isArray(resdata.agreement) && resdata.agreement.length > 0) {
                    this.setState({ 
                        agreeid:agreement.ctsaID,
                        expirydate: agreement.ctsa_agreement_end_date,                        
                        totalamount:resdata.totalamount,
                        selecttype:agreement.ctsa_program,
                        notdiv:false,
                        agrdiv:true 
                    });
                    let feesState = {};
                    let duedate = {};
                    let taxsState = {};

                    constract.forEach((instmnt, index) => {                    
                        const seldate = new Date(instmnt.ctfb_duedate);
                        feesState['frfees_' + (index + 1)] = instmnt.ctfb_fees;
                        taxsState['frtax_' + (index + 1)] = instmnt.ctfb_tax;
                        duedate['duedate_' + (index + 1)] = seldate;
                    });

                   
                    this.setState({
                        ...feesState,
                        ...duedate,
                        ...taxsState
                    });
                }else{
                    this.setState({ 
                         agrdiv:false,
                         notdiv:true
                    });
                }
                
            }
        });

    }

    calculateTax(event) {
        
        const fieldNumber = parseInt(event.target.getAttribute('data-field-number'));
        const am = parseFloat(event.target.value);
        const ta = 18;
        const total = (am * ta) / 100;
        this.setState(
            {
                [`frfees_${fieldNumber}`]: am,
                [`frtax_${fieldNumber}`]: am ? total : ''
            },
            () => {
                this.calculateTotal();
            }
        );
    }

    calculateTotal() {
        let total = 0;

        for (let i = 1; i <= 4; i++) {
            const fee = parseFloat(this.state['frfees_' + i]) || 0;
            const tax = parseFloat(this.state['frtax_' + i]) || 0;
            total += fee + tax;
        }

        this.setState({                       
            totalamount:total
        });
    }

    startfeedate = (date, fild, id) => {

        if (fild == 1) {
            const seldate = "duedate_" + id;
            this.setState({
                [seldate]: date
            });

        } 


    }

    addHandleSubmit(event) {
        event.preventDefault();
        
        this.setState({loader:true });
        this.props.addContractRenewal(event).then((data) => {
            this.setState({loader:false });
            if (data.status == 1) {
                this.setState({
                    student: '',
                    seldate: '',
                });

                document.getElementById("addform").reset();
            }
        });
    

    }


    render() {

        const { studentlists = [], allgolfprogram = [], loading } = this.props;
        const allstudent = studentlists.map((stdval) => {
            return {
                label: stdval.student,
                value: stdval.uudID
            }
        });

        const styles = {
            buttonProgress: {
                color: "blue",
                position: 'absolute',
                top: '65%',
                left: '50%',
                marginTop: -15,
                marginLeft: -15,
            },
            wrapper: {
                position: 'relative',
                textAlign:"center"
            },
        };

        return (
            <div>
                <div className="col-sm-12 col-lg-12">
                    <form autoComplete="off" id="addform" onSubmit={(e) => this.addHandleSubmit(e)}>
                        <div className="row">
                            <div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}>
                                <RctCollapsibleCard>
                                    <div className="dd">
                                        <h2 className="text-center">Contract Details</h2>
                                        <div className="col-sm-12 col-lg-12">
                                            <Label for="Select" style={{fontWeight:"bold"}}>Select Student</Label>
                                            <FormGroup>
                                                <Label for="Select" style={{fontWeight:"bold"}}>Select Student</Label>
                                                <Selectsearch id="student" options={allstudent} rules={{ required: 'Please select an student' }} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required />
                                                <input type="hidden" name="student" value={this.state.student} />
                                            </FormGroup>
                                        </div>                                        
                                    </div>

                                    {this.state.agrdiv &&    
                                    <div className="dd" style={{marginTop:"30px"}}> 
                                        <h2 className="text-center">Agreement Details</h2>   
                                        <div className="col-sm-12 col-lg-6">
                                            <FormGroup>
                                                <Label for="country">Expiry Date</Label>
                                                <input type="text" name="expirydate" id="expirydate" className="form-control form-control-alternative" value={this.state.expirydate} readOnly/>
                                            </FormGroup>
                                        </div>
                                        <div className="col-sm-12 col-lg-8">
                                            <FormGroup>
                                                <Label for="country">Select Program</Label>
                                            <select className="form-control" name="agreementtype" id="agreementtype" required value={this.state.selecttype} onChange={evt => this.setState({ selecttype: evt.target.value })}>
                                                <option value="">Select</option>
                                                {allgolfprogram.map((p, index) => (
                                                    <option value={p.id}>{p.name}</option>
                                                ))}  
                                                
                                            </select>
                                            </FormGroup>
                                        </div>    
                                        <div className="col-sm-12 col-lg-12">
                                            <FormGroup>
                                                <Label for="country">Installment Details</Label>
                                             </FormGroup> 
                                             <table class="table align-items-center">
                                                <thead style={{ backgroundColor: "transparent" }}>
                                                    <tr><th width="5%">SNo.</th>
                                                        <th width="11%">Due Date</th>
                                                        <th width="10%">Fees</th>
                                                        <th width="10%">Tax</th>
                                                    </tr></thead>
                                                <tbody>
                                                    
                                                    {(() => {
                                                        let Fragment = [];
                                                        
                                                        for (let j = 1; j <=4; j++) {
                                                           
                                                            var frduedate="frduedate_"+j;
                                                            var frfees="frfees_"+j;
                                                            var frtax="frtax_"+j;
                                                            Fragment.push(<tr>
                                                                <td>{j}</td>                                                                
                                                                <td>
                                                                    <DatePicker className="form-control" id={frduedate} name={frduedate} autoComplete="off"
                                                                        selected={this.state['duedate_'+j]}
                                                                        onChange={(e) => this.startfeedate(e, 1, j)}
                                                                        dateFormat='yyyy-MM-dd'
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                    />
                                                                </td> 
                                                                <td>
                                                                    <input
                                                                        className="form-control"
                                                                        type="number"
                                                                        name={frfees}
                                                                        id={`frfees_`+j+`_${this.props.id}`}
                                                                        value={this.state[`frfees_`+j] || ''}
                                                                        onChange={this.calculateTax}
                                                                        data-field-number={j}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name={frtax}
                                                                        id={frtax}
                                                                        readOnly
                                                                        value={this.state[`frtax_`+j] || ''}
                                                                    />
                                                                </td>
                                                                                                                       
                                                            </tr>);

                                                        }

                                                        return Fragment;
                                                 
                                                    })()}    
                                                </tbody>
                                            </table>
                                            
                                        </div>
                                        <div className="col-sm-12 col-lg-6">
                                            <FormGroup>
                                                <Label for="country">Total Amount</Label>
                                                <input type="text" name="totalamount" id="totalamount" className="form-control form-control-alternative" value={this.state.totalamount} onChange={evt => this.setState({ totalamount: evt.target.value })} reqired/>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="country">Miscellaneous Expense</Label>
                                                <input type="text" name="miscellexpense" id="miscellexpense" className="form-control form-control-alternative" value={this.state.miscellexpense} onChange={evt => this.setState({ miscellexpense: evt.target.value })}/>
                                            </FormGroup>
                                        </div>
                                        <div className="col-sm-12 col-lg-12">
                                            <FormGroup>
                                                <Label for="country">Additional Note</Label>
                                                <textarea row="5" name="additionalnotes" id="additionalnotes" className="form-control form-control-alternative" value={this.state.notes} onChange={evt => this.setState({ notes: evt.target.value })}></textarea>
                                            </FormGroup>  
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group" style={styles.wrapper}> 
                                                <input type="hidden" name="agreementid" id="agreementid" value={this.state.agreeid}/>
                                                <button type="submit" className="mr-10 mb-10 btn btn-outline-primary" disabled={this.state.loader} >Submit</button>
                                                    {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}   
                                                    <button type="button" className="mr-10 mb-10 btn btn-outline-warning" onClick={this.props.onClick} >Back</button> 
                                            </div>                                            
                                        </div>
                                    </div>
                                    }

                                    {this.state.notdiv &&    
                                    <div className="dd" style={{marginTop:"30px"}}> 
                                        <h4 style={{color:"red",textAlign:"center",fontWeight:"bold"}}>Contract not found</h4>
                                        <div className="form-group" style={{ textAlign: "center", marginTop: "20px" }}>
                                            <button type="button" className="mr-10 mb-10 btn btn-outline-warning" onClick={this.props.onClick}>Back</button>
                                        </div>
                                    </div>
                                    }

                                </RctCollapsibleCard>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        )

    }

}

const mapStateToProps = ({ mostlyused,contractstudent }) => {
    const { studentlists, loading } = mostlyused;
    const { allgolfprogram } = contractstudent;
    return { studentlists, allgolfprogram, loading };

}


export default connect(mapStateToProps, {
    allStudents,
    studentRecentAgreement,
    addContractRenewal,
    agreementAllDetails
})(AddItems);
